import images from "./images";

const projectsData1 = [
  {
    id: 1,
    title: "Villa écologique en brique de terre",
    image: images.villa2,
    link: "/villa1",
  },
  {
    id: 2,
    title: "Conception d'une villa de type F4",
    image: images.villa9,
    link: "/villa2",
  },
  {
    id: 3,
    title: "Conception d'une villa de type F5",
    image: images.travaux4,
    link: "/villa3",
  },
  {
    id: 4,

    title: "Maison plein pieds de type F5",
    image: images.house2,
    link: "/house",
  },
  {
    title: "Conception d'une villa de type F4",
    image: images.travaux5,
    link: "/villa2",
  },
];

const projectsData2 = [
  {
    id: 1,
    title: "Appartement de type F3",
    image: images.villa5,
    link: "/apartment",
  },
  {
    id: 2,
    title: "Conception d'une villa de type F5",
    image: images.travaux4,
    link: "/villa3",
  },
  {
    id: 3,
    title: "Conception d'une villa de type F4",
    image: images.villa9,
    link: "/villa2",
  },

  {
    id: 4,

    title: "Maison plein pieds de type F5",
    image: images.house2,
    link: "/house",
  },
  {
    title: "Conception d'une villa de type F4",
    image: images.travaux5,
    link: "/villa2",
  },
];

export { projectsData1, projectsData2 };
